<script> 
    import { onMount } from "svelte";
    import  { resolveExportUrl } from "../../router.js";
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from "../components/card.svelte";  
    import Spinner from "../components/spinner.svelte";
    import NoDataFound from "../components/nodatainfo.svelte";
    
    export let providerId;

    let isPageLoading = true;
    let logNumbers;
    let params;
    let titleProvider =  providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";

    const getLogNumbers = async () => {
        isPageLoading = true;
        let resp = await wrappedFetch(
            `/api/cloudConfig/GetExportLogs?providerId=${providerId}`,
            { method: "post" }
        );

        logNumbers = (await resp.json()).result;
        // console.log(logNumbers);
        if(logNumbers){
            params = {
                pupilsProcessed: logNumbers.processedPupils,
                pupilsPending: logNumbers.pendingPupils,
                pupilsErrors: logNumbers.errorsPupil,
                staffProcessed: logNumbers.processedStaff,
                staffPending: logNumbers.pendingStaff,
                staffErrors: logNumbers.errorsStaff
            };
        }

        isPageLoading = false;
    };

    onMount( async () => {
        await getLogNumbers();
    });
</script>
<style>
     .error{
        color: red;
        font-weight: 500;
    }
    .processed{
        color: #2b76e9;
        font-weight: 500;
    }
    .pending{
        color:orange;  /* rgb(236, 80, 76); */
        font-weight: 500;
    }  
    .material-icons{
        vertical-align: bottom;
    }
    .btn-white{
        color: #2e817d;
        border: 1px solid #2e817d;
        margin-top: 20%;
    }
    h5{
        color: #2e817d; /*  #ec504c; */
    }
</style>

<!-- <slot name="header"/> -->

<svelte:head>
    <title> Logs for {titleProvider} | Wavenet Nimbus </title>
</svelte:head>

{#if isPageLoading}
    <Spinner />
{:else if logNumbers == null}
    <h1>Detailed Logs</h1>
    <NoDataFound infoText="No Data Found">
        <p>Please ensure the configuration has been completed and data has been exported. Please click the 'Configuration' button below to view the settings.</p>
        <a class="btn btn-primary" href={resolveExportUrl(providerId,"/summary")}>Configuration</a>
    </NoDataFound>
{:else}
    <Card>
        <div slot="body">
            <div style="float: left;">
                <h5>
                    <span class="material-icons">group_add</span>
                    New users
                </h5>
                <p>The users who had new accounts created by the sync.</p>
            </div>
            <div style="float: right;">
                <a class="btn btn-white" href="/app/export/{providerId}/newUsers">Show</a>
            </div>
        </div>
    </Card>
    <br />
    <Card>
        <div slot="body">
            <div style="float: left;">
                <h5>
                    <span class="material-icons">list_alt</span>
                    Detailed logs
                </h5>
                <p>
                    On the last export there were <span class="processed">{params.pupilsProcessed}</span> new students and 
                    <span class="processed">{params.staffProcessed}</span> new staff processed 
                    with <span class="error">{params.pupilsErrors + params.staffErrors}</span> errors.
                </p>
            </div>
            <div style="float: right;">
                <a class="btn btn-white" href="/app/export/{providerId}/syncLogs">Show</a>
            </div>
        </div>
    </Card>
{/if}